export const getExtension = (file: File): string | "unknown" => {
  const indexOfDot = file.name.lastIndexOf(".");
  if (indexOfDot < 0 || indexOfDot + 1 === file.name.length) {
    return "unknown";
  }
  return file.name.slice(indexOfDot + 1);
};
